module.exports = __webpack_public_path__ + "static/media/Home Page_website-13.83f66d18.png";